// The words of signing in by email and of the account. Those marked "today's"
// are today's pages' (welcome/words.ts, settings/words.ts there); the rest
// are new, for the person to read before they are anybody's copy.

export const emailWords = {
  /** Today's: the address's field. */
  field: 'Email',
  /** Today's. */
  go: 'Continue',
  /** Today's: what the server refuses as no address. */
  notAnAddress: 'Enter an email address.',

  check: {
    /** Today's. */
    title: 'Check your email',
    /** Today's: said whatever the address's account, which the page never learns. */
    sent: 'We sent a link to {address}.',
    /** Today's, in the Mac app. */
    openOnMac: 'Open it on this Mac.',
    /** New: a browser keeps the link's verifier, so the link opens only in it. */
    openInBrowser: 'Open it in this browser.',
    /** Today's. */
    other: 'Use another address',
  },

  link: {
    /** Today's "Signing in", with the new pages' ellipsis. */
    finishing: 'Signing in…',
    /** Today's. */
    refused: 'That link did not work. Ask for a new one.',
    /** New: no verifier here for the link's attempt. */
    elsewhere: 'This link was asked for on another device or browser. Open it there, or start again here.',
    /** Today's. */
    restart: 'Start again',
  },
}

export const accountWords = {
  name: 'Name',
  workspace: 'Workspace',
  /** Today's. */
  email: 'Email',
  /** New. */
  addEmail: 'Add an address',
  /** New: the address's field, once adding. */
  newAddress: 'Email address',
  cancel: 'Cancel',
  /** Today's "Passkey", now that a person may have several. */
  passkeys: 'Passkeys',
  /** Today's. */
  addPasskey: 'Add a passkey',
  /** New. */
  count: (n: number) => (n === 1 ? '1 passkey' : `${n} passkeys`),
  /** Today's "Added", with when. */
  added: 'Added',
  /** New: after an email sign-up. */
  none: 'No passkey yet.',
  /** Today's, from the welcome's offer of a passkey. */
  why: 'Sign in next time with Touch ID, without an email.',
  /** New. */
  most: 'An account holds ten passkeys at most.',
  /** New: no passkey to confirm with, and a session too old to add one without. */
  notFresh: 'Sign in again by email to add a passkey.',
  /** Today's. */
  unread: 'The account could not be read.',
  /** Today's. */
  retry: 'Try again',
  /** New, leading the server's words. */
  emailFailed: 'Could not add the address',
  /** New, leading the server's words. */
  passkeyFailed: 'Could not add the passkey',
  /** New: a passkey its person has not named. */
  unnamed: 'Passkey',
  /** New: when it last signed in or confirmed, with when. */
  lastUsed: 'Last used',
  /** New: a passkey that has not signed in or confirmed yet. */
  neverUsed: 'Not used yet',
  rename: 'Rename',
  remove: 'Remove',
  save: 'Save',
  /** New: the name's field. */
  passkeyName: 'Passkey name',
  /** New, leading the server's words. */
  renameFailed: 'Could not rename the passkey',
  /** New, leading the server's words. */
  removeFailed: 'Could not remove the passkey',
  /** New: the person's last passkey, with no address to sign in with instead. */
  lastPasskey: 'This is your last passkey. Add an email address first, so that you can still sign in.',
  /** New (Poulpe-686): whether the person's actions ask for their passkey. */
  confirmActions: 'Confirm actions with a passkey',
  /** New: what it covers while on, and what turning it off takes. */
  confirmOn: 'Approving a landing, saving a landing policy, making a runner code, and changing your address or passkeys ask for your passkey. Turning this off asks for it one last time.',
  /** New: what it covers while off. */
  confirmOff: 'Approving a landing, saving a landing policy, making a runner code, and changing your address or passkeys ask for no passkey: being signed in is enough.',
  /** New, leading the server's words. */
  confirmFailed: 'Could not change how you confirm actions',
}

/** The sentence under "Check your email", split around the address, which the page sets in the text's own ink. */
export function sentAround(): [string, string] {
  const [before = '', after = ''] = emailWords.check.sent.split('{address}')
  return [before, after]
}

/** New: the page a sign-in mail's button opens, which hands the link on to the Mac app (OpenApp.tsx). */
export const openAppWords = {
  opening: 'Opening Poulpe…',
  ifNothing: 'If Poulpe does not open, use the button.',
  open: 'Open Poulpe',
  close: 'Once Poulpe is open, you can close this tab.',
  notALink: 'This is not a sign-in link',
  askAgain: 'Ask for a new link in Poulpe.',
}
